import { registerPlugin } from '@capacitor/core';
const FirebaseUpload = registerPlugin('FirebaseUpload', {
    web: () => import('./web').then(m => new m.FirebaseUploadWeb()),
});
export * from './definitions';
export { FirebaseUpload };
